import React from 'react';
import { PrimaryButton } from './PrimaryButton';
import { ScreenTitle } from './ScreenTitle';
import { ScreenDescription } from './ScreenDescription';
import { VerticalStack } from './VerticalStack';
import { designTokens } from '../../constants/designTokens';
import { useLanguage } from '../../i18n';

interface ErrorStateProps {
  title?: string;
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const ErrorState = React.memo(function ErrorState({
  message,
  title,
  actionLabel,
  onAction,
  className = '',
  style,
}: ErrorStateProps) {
  const { t } = useLanguage();
  const resolvedTitle = title || t('errorState.title');
  const resolvedActionLabel = actionLabel || t('common.tryAgain');

  return (
    <div
      className={`error-state ${className}`}
      style={{
        padding: designTokens.spacing.xl,
        textAlign: 'center',
        ...style,
      }}
    >
      <VerticalStack spacing="lg" align="center">
        <div
          className="error-icon"
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: designTokens.colors.red.bg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: designTokens.colors.red.text,
            fontSize: '40px',
            marginBottom: designTokens.spacing.lg,
          }}
        >
          ⚠
        </div>

        <ScreenTitle size="lg">{resolvedTitle}</ScreenTitle>
        <ScreenDescription size="lg">{message}</ScreenDescription>

        {onAction && (
          <PrimaryButton
            onClick={onAction}
            style={{ marginTop: designTokens.spacing.lg }}
          >
            {resolvedActionLabel}
          </PrimaryButton>
        )}
      </VerticalStack>
    </div>
  );
});
